export default "__VITE_ASSET__BoMd$6yZ__"